import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { useCities } from '../../hooks/useCities'

const { Option } = Select

export interface City {
    cityId: string
    cityName: string
    secondaryName: string
    whatsappGroupLink?: string
}

interface CitySelectorProps {
    value?: string
    onChange?: (cityId: string) => void
    placeholder?: string
    size?: 'small' | 'middle' | 'large'
    className?: string
    disabled?: boolean
    allowClear?: boolean
}

export const CitySelector: React.FC<CitySelectorProps> = ({
    value,
    onChange,
    placeholder,
    size = 'middle',
    className,
    disabled = false,
    allowClear = false,
}) => {
    const { t } = useTranslation()
    const { cities, isLoading, error } = useCities()
    const defaultPlaceholder = placeholder || t('common.selectCity')

    const handleChange = (cityId: string) => {
        if (onChange) {
            onChange(cityId)
        }
    }

    return (
        <>
            <Select
                placeholder={
                    error
                        ? t('common.citiesUnavailable')
                        : defaultPlaceholder
                }
                value={value || undefined}
                onChange={handleChange}
                loading={isLoading}
                size={size}
                className={className}
                disabled={disabled || !!error}
                allowClear={allowClear}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                    const children = option?.children as
                        | string
                        | React.ReactNode
                    if (typeof children === 'string') {
                        return children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    // Handle ReactNode case - convert to string for comparison
                    if (children) {
                        const text = String(children)
                        return text.toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                }}
                notFoundContent={
                    error
                        ? t('common.citiesUnavailable')
                        : isLoading
                          ? t('common.loadingCities')
                          : t('common.noCitiesFound')
                }
            >
                {cities.map((city) => (
                    <Option key={city.cityId} value={city.cityId}>
                        {city.cityName}
                    </Option>
                ))}
            </Select>
        </>
    )
}
